import type { V1Event } from '@/generated/hooks/rain/models';

export const ROOT_TASK_SCOPE = 'root';

export const getEventTaskScope = (event: V1Event): string =>
  event.task_id ?? ROOT_TASK_SCOPE;

/**
 * `V1Event.recorded_at_ms` as a usable epoch, or `undefined`.
 *
 * The field is a STRING on the wire, so presence is not usability: `''` or
 * anything non-numeric reaches `Number()` as `NaN` or `0` and would stamp a
 * message with `Invalid Date` or 1970. Every consumer handles a missing
 * timestamp; a wrong one silently misleads whatever reads it next — and
 * lattice renders `Invalid Date` straight into a message's aria-label.
 *
 * One rule, shared by both paths that stamp a message: the reasoning/assistant
 * stretches routed in the hook, and the tool calls stamped in
 * `applyToolCallStart`.
 */
export const parseRecordedAtMs = (
  recordedAtMs: string | undefined,
): number | undefined => {
  const parsed = Number(recordedAtMs);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};
